window.__VUE_PROD_DEVTOOLS__ = false;
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
function hideConsoles() {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.info = () => {};
  console.debug = () => {};
}
hideConsoles();

import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import store from "./store";
import { Amplify } from "aws-amplify";
loadFonts();

// Vuetify fields/menus inside scrollable tables can trigger benign
// ResizeObserver loop warnings in dev. Debounce callbacks to the next frame.
const NativeResizeObserver = window.ResizeObserver;
if (NativeResizeObserver) {
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

window.addEventListener("error", (event) => {
  const message = event?.message || "";
  if (
    message.includes("ResizeObserver loop completed") ||
    message.includes("ResizeObserver loop limit exceeded")
  ) {
    event.stopImmediatePropagation();
    event.preventDefault?.();
  }
});

import disableDevtool from "disable-devtool";
// Local development only: set VUE_APP_DISABLE_DEVTOOL_GUARD=true in .env.local
if (process.env.VUE_APP_DISABLE_DEVTOOL_GUARD !== "true") {
  disableDevtool({
    disableMenu: true,
    clearLog: true,
    ondevtoolopen: () => {
      window.location.replace("https://google.com", "__blank");
    },
  });
}

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.VUE_APP_AWS_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.VUE_APP_AWS_USER_POOL_WEB_CLIENT_ID,
      identityPoolId: process.env.VUE_APP_AWS_IDENTITY_POOL_ID,
      loginWith: {
        email: true,
      },
    },
  },

  API: {
    GraphQL: {
      endpoint: process.env.VUE_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT,
      region: process.env.VUE_APP_AWS_APPSYNC_REGION,
      defaultAuthMode: process.env.VUE_APP_AWS_AUTHENTICATION_TYPE,
    },
  },
  Storage: {
    S3: {
      bucket: process.env.VUE_APP_AWS_S3_BUCKET_NAME,
      region: process.env.VUE_APP_AWS_S3_BUCKET_REGION,
    },
  },
});
// console.log("hello",Amplify.getConfig());
createApp(App).use(store).use(router).use(vuetify).mount("#app");
